import { render, staticRenderFns } from "./DbToaster.vue?vue&type=template&id=19c2ddca&scoped=true"
import script from "./DbToaster.vue?vue&type=script&lang=js"
export * from "./DbToaster.vue?vue&type=script&lang=js"
import style0 from "./DbToaster.vue?vue&type=style&index=0&id=19c2ddca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c2ddca",
  null
  
)

export default component.exports